<template>
  <div class="hello">
    <el-container style="height: 100vh;">
      <el-header>
        <div style="text-align: left;display: flex">
          <el-upload
            v-loading="loading"
            class="el-upload-class"
            drag
            :action="actionUrl"
            :on-success="handleUploadSuccess"
            :on-progress="handleOnProgress"
            :show-file-list="false"
            multiple
          >
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
          <el-button class="clear-btn" type="danger" plain icon="el-icon-delete" @click="clearFile">清除文件</el-button>
          <div class="title-content">已上传{{ fileNameList.length }}个文件<span v-if="machineType">,机台类型为{{ machineType }}</span></div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="300px">
          <div class="selection-title">- 选项</div>
          <el-form label-width="100px">
            <el-form-item label="旋转">
              <el-select v-model="type" style="width: 150px">
                <el-option :value="0" label="默认" />
                <el-option :value="1" label="顺时针90" />
                <el-option :value="2" label="180" />
                <el-option :value="3" label="逆时针90" />
              </el-select>
            </el-form-item>
            <el-form-item label="X轴镜面翻转">
              <el-radio v-model="mirrorX" :label="false">否</el-radio>
              <el-radio v-model="mirrorX" :label="true">是</el-radio>
            </el-form-item>
            <el-form-item label="Y轴镜面翻转">
              <el-radio v-model="mirrorY" :label="false">否</el-radio>
              <el-radio v-model="mirrorY" :label="true">是</el-radio>
            </el-form-item>
            <el-form-item label="生成方式">
              <el-select v-model="createType" style="width: 150px" @change="getList">
                <el-option :value="0" label="取最后出现" />
                <el-option :value="1" label="取最先出现" />
                <el-option :value="2" label="取最大值" />
              </el-select>
            </el-form-item>
            <el-form-item label="颜色">
              <el-tag
                v-for="(tag,index) in dynamicTags"
                :key="index"
                closable
                :disable-transitions="false"
                :color="tag.color"
                class="tag-text-color"
                @close="handleClose(tag)"
              >
                <span>
                  {{ tag.scope|scopeFormatter }}
                </span>
              </el-tag>
              <el-popover
                v-model="popoverVisible"
                placement="top"
                width="200"
              >
                <el-form
                  ref="colorForm"
                  :model="colorForm"
                  label-width="50px"
                  label-position="left"
                  :rules="colorFormRules"
                >
                  <el-form-item label="范围" prop="scope">
                    <el-input
                      ref="saveTagInput"
                      v-model="colorForm.scope"
                      class="input-new-tag"
                      size="small"
                      @input="checkInput"
                    />
                  </el-form-item>
                  <el-form-item label="颜色">
                    <el-color-picker v-model="colorForm.color" />
                  </el-form-item>
                </el-form>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="popoverVisible=false">取消</el-button>
                  <el-button type="primary" size="mini" @click="confirmColor">确定</el-button>
                </div>
                <el-button slot="reference" class="button-new-tag" size="small">+ New Tag</el-button>
              </el-popover>
            </el-form-item>
          </el-form>
          <el-button :v-loading="listLoading" :disabled="fileNameList.length===0" type="primary" @click="getList">生成图片</el-button>
          <el-button v-loading="listLoading" :disabled="JSON.stringify(dataList) === '{}'" @click="downloadCsv">导出</el-button>
        </el-aside>
        <el-container>
          <el-main>
            <csv-image
              v-if="show"
              ref="csvImage"
              :max-x="maxX"
              :min-x="minX"
              :max-y="maxY"
              :min-y="minY"
              :type="type"
              :mirror-x="mirrorX"
              :mirror-y="mirrorY"
              :point-list="dataList"
              :color-type="dynamicTags"
            />
          </el-main>
        </el-container>
      </el-container>
    </el-container>
  </div>
</template>

<script>

import CsvImage from './csv-image'
import { clear, getFileNameList, getJson, getType } from '@/api/convert-csv'

export default {
  name: 'HelloWorld',
  components: {
    CsvImage
  },
  filters: {
    scopeFormatter: function(val) {
      const array = [...val]
      array.sort(function(a, b) { return a - b })
      var msg = '' + array[0]
      var tmp = array[0]
      if (array.length > 1) {
        for (let i = 1; i < array.length; i++) {
          const valElement = array[i]
          // 上一个和现在是否连续
          if (tmp + 1 !== valElement) {
            //  24!=30  30!= 33
            // 判断是否有横条,有横条就要结尾,要加tmp
            if (msg.endsWith('-')) {
              msg = msg + tmp + ',' + valElement// -24,30
            } else {
              msg = msg + ',' + valElement
            }
          } else {
            // 连续,判断是否开始横条,没有就加上
            if (!msg.endsWith('-')) {
              msg = msg + '-'
            }
            if (i + 1 === array.length) {
              msg += valElement
            }
          }
          tmp = valElement
        }
      }
      return msg
    }
  },
  data() {
    const validate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入范围'))
      } else {
        if (value.match(/^([0-9]+(-[0-9]+)?,)*[0-9]+(-[0-9]+)?$/)) {
          const scope = value.split(',')
          const set = new Set()
          scope.forEach(v => {
            if (v.indexOf('-') === -1) {
              set.add(parseInt(v))
            } else {
              const strings = v.split('-')
              const num1 = parseInt(strings[0])
              const num2 = parseInt(strings[1])
              for (let i = Math.min(num1, num2); i <= Math.max(num1, num2); i++) {
                set.add(i)
              }
            }
          })
          //
          const oldSet = new Set()
          this.dynamicTags.forEach(v => {
            const scope1 = v.scope
            scope1.forEach(w => {
              oldSet.add(w)
            })
          })
          const result = []
          set.forEach(v => {
            if (oldSet.has(v)) {
              result.push(v)
            }
          })
          if (result.length > 0) {
            callback(new Error('已存在的元素: ' + result))
          }
          callback()
        } else {
          callback(new Error('格式有误'))
        }
      }
    }
    return {
      actionUrl: process.env['VUE_APP_BASE_API'] + process.env['VUE_APP_CSV_API'] + '/upload-csv',
      dataList: {},
      show: false,
      maxX: 0,
      minX: 0,
      maxY: 0,
      minY: 0,
      machineType: undefined,
      type: 0,
      mirrorX: false,
      mirrorY: false,
      createType: 0,
      loading: false,
      dynamicTags: [{ scope: [1], color: '#5DA569' }],
      popoverVisible: false,
      colorForm: {
        scope: '',
        color: '#FFFFFF'
      },
      colorFormRules: {
        scope: [{ validator: validate, trigger: 'blur' }]
      },
      listLoading: false,
      fileNameList: []
    }
  },
  created() {
    this.getCount()
    this.getType()
  },
  methods: {
    getList() {
      this.listLoading = true
      if (this.fileNameList.length === 0) {
        this.listLoading = false
        return
      }
      this.show = false
      getJson({ type: this.createType }).then(res => {
        const data = res
        if (data) {
          const obj = {}
          data.points.forEach(v => {
            obj[v.x * 1000 + v.y] = v.bin
          })
          this.dataList = obj
          this.maxX = data.maxX
          this.minX = data.minX
          this.maxY = data.maxY
          this.minY = data.minY
          this.show = true
          this.$nextTick(() => {
            // this.$refs.csvImage.init()
          })
        }
      })
        .finally(() => {
          this.listLoading = false
        })
    },
    clearFile() {
      clear().then(res => {
        this.fileNameList = []
        this.machineType = undefined
      })
    },
    handleUploadSuccess(res) {
      if (res.status) {
        this.getCount()
        this.machineType = res.type
        this.$message.success('上传成功..')
      } else {
        this.$message.error('文件类型不一致!')
      }
      this.loading = false
    },
    handleOnProgress() {
      this.loading = true
    },
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
    },
    checkInput(val) {
      this.colorForm.scope = val.replace(/[^0-9\-,]/g, '')
    },
    confirmColor() {
      this.$refs.colorForm.validate((valid) => {
        if (valid) {
          const scope = this.colorForm.scope.split(',')
          const set = new Set()
          scope.forEach(v => {
            if (v.indexOf('-') === -1) {
              set.add(parseInt(v))
            } else {
              const strings = v.split('-')
              const num1 = parseInt(strings[0])
              const num2 = parseInt(strings[1])
              for (let i = Math.min(num1, num2); i <= Math.max(num1, num2); i++) {
                set.add(i)
              }
            }
          })
          const inputValue = {
            scope: Array.from(set),
            color: this.colorForm.color
          }
          this.dynamicTags.push(inputValue)
          this.popoverVisible = false
          this.colorForm = {
            scope: '',
            color: '#FFFFFF'
          }
        }
      })
    },
    downloadCsv() {
      // 将数据转换为csv
      let csv = ''
      if (this.type % 2 === 0) {
        for (let i = 1; i <= ((this.maxX - this.minX) + 1); i++) {
          for (let j = 1; j <= ((this.maxY - this.minY) + 1); j++) {
            const toOriginal = this.$refs.csvImage.convertToOriginal(i, j)
            const tmpX = toOriginal[0]
            const tmpY = toOriginal[1]
            const bin = this.dataList[tmpX * 1000 + tmpY]
            let text = ','
            if (bin) {
              text = bin + text
            }
            csv += text
          }
          csv += '\n'
        }
      } else {
        for (let i = 1; i <= ((this.maxY - this.minY) + 1); i++) {
          for (let j = 1; j <= ((this.maxX - this.minX) + 1); j++) {
            const toOriginal = this.$refs.csvImage.convertToOriginal(i, j)
            const tmpX = toOriginal[0]
            const tmpY = toOriginal[1]
            const bin = this.dataList[tmpX * 1000 + tmpY]
            let text = ','
            if (bin) {
              text = bin + text
            }
            csv += text
          }
          csv += '\n'
        }
      }
      const uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv)
      const link = document.createElement('a')
      link.href = uri
      link.download = 'export.csv'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    getCount() {
      getFileNameList().then(res => {
        console.log('res', res)
        this.fileNameList = res
      })
    },
    getType() {
      getType().then(res => {
        if (res !== 'NONE') {
          this.machineType = res
        }
      })
    }
  }
}
</script>

<style scoped>

.el-upload-class {
  padding: 5px;
}
.el-upload-class ::v-deep.el-upload-dragger{
  width: 200px;
  height: 50px;
  line-height: 47px;
}
.clear-btn{
  margin: 5px 0 10px 20px;
}
.title-content{
  margin-left: 50px;
  width: 100%;
  font-size: 26px;
  line-height: 55px;
}
.selection-title{
  margin: 30px;
  text-align: left;
  font-size: 40px;
}
.el-header, .el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
}

.el-main {
  background-color: #E9EEF3;
  color: #333;
  text-align: center;
}

body > .el-container {
  margin-bottom: 40px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  vertical-align: bottom;
}
.tag-text-color{
  color: white;
  font-size: 22px;
  -webkit-text-stroke: 1px black;
}

</style>
